import { Button, Icon, Sheet } from '@gravity-ui/uikit';
import { Xmark } from '@gravity-ui/icons';
import { OUT, STAY } from 'features/profile/constants';
import styles from './styles.module.scss';

export const SheetOut = ({ visible, setVisible, handleLogOut }: any) => {
	return (
		<Sheet
			visible={visible}
			onClose={() => setVisible(false)}
			title="Вы действительно хотите выйти?"
			className={styles.sheet}
		>
			<div className={styles.sheet__title}>
				<Button onClick={() => setVisible(false)} view="flat">
					<Icon data={Xmark} size={16} />
				</Button>
			</div>

			<div className={styles.sheet__btns}>
				<Button onClick={handleLogOut} size="xl" className={styles.sheet__btns__return}>
					{OUT}
				</Button>
				<Button onClick={() => setVisible(false)} size="xl" view="flat" className={styles.sheet__btns__stay}>
					{STAY}
				</Button>
			</div>
		</Sheet>
	);
};
